import { useEffect } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { usePageLoadStatus } from 'src/hooks/usePageLoadStatus';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  ALL_INVENTORY_VIEW_PERMISSIONS,
  ALL_SALES_VIEW_PERMISSIONS,
  hasAccessToRoute,
} from 'src/utils/userUtils';
import { Feature, Permission } from 'src/WebApiController';

import { Dashboard } from '../Dashboard';
import { MainRoute } from '../MainRoute';

export function Home() {
  const { registerComponent } = usePageLoadStatus();
  const { loginContext, appContext } = useAppContext();

  // Determine which components will be rendered based on permissions and feature flags
  const hasHomePageActivityLogFeature = useUserHasFeature(
    Feature.HomePageActivityLog
  );
  const hasViewSalesPermission = useUserHasAnyOfPermissions(
    ...ALL_SALES_VIEW_PERMISSIONS
  );
  const hasViewListingsPermission = useUserHasAnyOfPermissions(
    ...ALL_INVENTORY_VIEW_PERMISSIONS
  );
  const hasViewSalesDataPermission = useUserHasAnyOfPermissions(
    Permission.Sales_ViewHomePageMetrics
  );
  const hasNotificationsAccess = hasAccessToRoute(
    loginContext?.user,
    appContext?.features,
    MainRoute.Notifications
  );

  useEffect(() => {
    // Register all components that might be rendered
    registerComponent('LayoutContent');

    if (hasViewListingsPermission) {
      registerComponent('MetricsSection');
    }

    if (hasViewSalesDataPermission) {
      registerComponent('DataInsightsChartSection');
    }

    if (hasViewSalesPermission) {
      registerComponent('RecentSalesSection');
    }

    if (hasHomePageActivityLogFeature) {
      registerComponent('ActivitySection');
    }

    if (hasNotificationsAccess) {
      registerComponent('NotificationsSection');
    }
  }, [
    registerComponent,
    hasViewListingsPermission,
    hasViewSalesDataPermission,
    hasViewSalesPermission,
    hasHomePageActivityLogFeature,
    hasNotificationsAccess,
  ]);

  return <Dashboard />;
}
